import { combineReducers } from 'redux'

 import Auth from './reducers/authReducers'
import Groupreducer from "./reducers/groupReducer"
import Templatereducer from "./reducers/templateReducer"
import campaignReducer from "./reducers/campaignReducers"
import freeuserReducer from "./reducers/freeuserReducer"
import myorganizationReducers from "./reducers/myorganizationReducers"
import DomainReducer from './reducers/domainReducer'
import LoginTemplateReducer from './reducers/loginTemplateReducer'
import conversationReducer from './reducers/conversationReducer'

const rootReducer = combineReducers({
    Auth,
    Groupreducer,
    Templatereducer,
    campaignReducer,
    freeuserReducer,
    myorganizationReducers,
    DomainReducer,
    LoginTemplateReducer,
    conversationReducer

})

export default rootReducer